import { CSSTransition, SwitchTransition } from 'react-transition-group';
import React, { useRef } from 'react';
import { logIn, logOut } from '../utility/index.js';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import LockIcon from '@mui/icons-material/Lock';

const RenderLogin = () => {
  return <div className="userpanel-account" >
    <div className="userpanel-account-avatar">
      <AccountCircleIcon />
    </div>
    <div className="userpanel-account-user"> <span className="userpanel-account-user-name">Guest</span> </div>
    <span className="userpanel-account-link" onClick={() => logIn()}>
      <LockIcon />
      <span>Login</span>
    </span>
  </div>
}

const RenderAccount = (props) => {
  const { currentUser } = props;
  return <div className="userpanel-account">
    <div className="userpanel-account-avatar">
      <AccountCircleIcon />
    </div>
    <div className="userpanel-account-user">
      <span className="userpanel-account-user-name">{currentUser.commonName}</span>
      <span className="userpanel-account-user-email">{currentUser.email}</span>
    </div>
    <div className="mdl-menu__item--container">
      <div className="mdl-menu__item--logout" onClick={() => logOut()}>
        <ExitToAppIcon />
        <span>Logout</span>
      </div>
    </div>
  </div>
}


const UserPanel = (props) => {
  const { currentUser } = props;
  const accountRef = useRef(null);
  const loginRef = useRef(null);
  const nodeRef = currentUser !== 'Guest' ? accountRef : loginRef;

  return (
    <div className="userpanel" style={{ width: "100%" }}>
      <SwitchTransition>
        <CSSTransition
          key={currentUser !== 'Guest' ? "account" : "login"}
          nodeRef={nodeRef}
          addEndListener={(node, done) => node.addEventListenr("transitioned", done, false)}
          classNames='fade'
        >
          {
            currentUser !== 'Guest' ?
              <RenderAccount currentUser={currentUser} />
              :
              <RenderLogin />

          }
        </CSSTransition>
      </SwitchTransition>

    </div>
  )
}

export default UserPanel;